import { colors } from "./index"
import { fonts, fontSizer } from "./index"

export const headlineOne = `
    ${fontSizer(3.6, 8, 76.8, 150, 2.8)}
    color: ${colors.black}
    font-family: ${fonts.fontSecondary};
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    line-height: 1.13;
  `

export const headlineTwo = `
    ${fontSizer(2.2, 3, 76.8, 160, 2)}
    color: ${colors.black}
    font-family: ${fonts.fontSecondary};
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
`

export const headlineThree = `
    ${fontSizer(4, 9, 76.8, 160, 4)}
    color: ${colors.colorAccent}
    font-family: ${fonts.fontTert};
    font-weight: normal;
    font-stretch: normal;
    font-style: italic;
    line-height: 1;
    letter-spacing: normal;
`

export const headlineThreeSmall = `
    ${fontSizer(2.6, 5, 76.8, 160, 3)}
    color: ${colors.colorAccent}
    font-family: ${fonts.fontTert};
    font-weight: normal;
    font-stretch: normal;
    font-style: italic;
    line-height: 1;
    letter-spacing: normal;
`

export const headlineFour = `
    ${fontSizer(2, 3, 76.8, 160, 3)}
    color: ${colors.colorAccent}
    font-family: ${fonts.fontSecondary};
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    font-style: normal;
    ine-height: 1.33;
    letter-spacing: normal;
`

export const headlineFive = `
    ${fontSizer(3, 5.5, 76.8, 150, 2.4)}
    color: ${colors.black}
    font-family: ${fonts.fontSecondary};
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    line-height: 1.13;
  `
